import { graphql } from "@/graphql/generated";
import { RemoveMunicipalPropertyYearMutation, RemoveMunicipalPropertyYearMutationVariables } from "@/graphql/generated/graphql";
import { TypedDocumentNode } from "@graphql-typed-document-node/core";

export const REMOVE_MUNICIPAL_PROPERTY_YEAR_MUTATION_DOCUMENT: TypedDocumentNode<RemoveMunicipalPropertyYearMutation, RemoveMunicipalPropertyYearMutationVariables> = graphql(/* GraphQL */ `
    mutation RemoveMunicipalPropertyYear($input: RemoveMunicipalPropertyYearInput!) {
      removeMunicipalPropertyYear(input: $input) { id }
    }
  `);
